import React from "react";
import dynamic from "next/dynamic";

const FeaturesBlock = dynamic(
  () => import("components/PartnerHomePageNew/FeatureBlock"),
  {ssr: true}
);

const LottieFeatureBlock = dynamic(
  () => import("components/PartnerHomePageNew/FeatureBlock").then(mod => {
    return import("./FeatureBlockLottie.json").then(animationData => {
      const FeatureBlock = mod.default;
      return {
        default: (props) => <FeatureBlock {...props} lottieAnimation={animationData.default || animationData} />
      };
    });
  }),
  {ssr: false, loading: () => <div style={{minHeight: "400px"}} />}
);

function HomePageFeatures({ features = [] }) {
  return (
    <>
      {features.map((feature, index) => (
        feature.hasLottie ? (
          <LottieFeatureBlock key={index} {...feature} />
        ) : (
          <FeaturesBlock key={index} {...feature} />
        )
      ))}
    </>
  );
}
export default HomePageFeatures;
